import { render, staticRenderFns } from "./file-upload-dialog.vue?vue&type=template&id=4c89420a&scoped=true&"
import script from "./file-upload-dialog.vue?vue&type=script&lang=js&"
export * from "./file-upload-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c89420a",
  null
  
)

export default component.exports